import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
const FB_PIXEL_ID = '1583309636230630';
function loadFbPixel() {
  if (typeof window === 'undefined') return;
  if ((window as any).fbq) return;
  const f = window as any;
  const n: any = function () {
    if (n.callMethod) {
      n.callMethod.apply(n, arguments);
    } else {
      n.queue.push(arguments);
    }
  };
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as any[];
  f.fbq = n;
  f._fbq = n;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
}
export function fbq(...args: any[]) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq(...args);
  }
}
export function App() {
  useEffect(() => {
    loadFbPixel();
    fbq('init', FB_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cyber-black text-gray-300 font-sans relative selection:bg-cyber-neon selection:text-cyber-black" data-id="element-0">
      {/* Global Scanline Overlay */}
      <div className="scanlines" data-id="element-1"></div>

      {/* Sticky Urgency Bar */}
      <UrgencyBar data-id="element-2" />

      {/* Main Content */}
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <HookSection data-id="element-5" />
        <PainSection data-id="element-6" />
        <RevelationSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <OfferSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
      </main>

      {/* Footer */}
      <Footer data-id="element-14" />
    </div>;
}